<p-calendar #calendarObject
            [(ngModel)]="inputDate"
            [required]="required"
            dateFormat="m/d/yy"
            (onSelect)="emitOutput()">
    <p-footer *ngIf="showClearButton"><i class="fa fa-times" style="font-size:18px; color:red; padding:10px;" (click)="clearDate()"></i></p-footer>
</p-calendar>
